var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTuto2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.72 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #8a6acf;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.75,
    cy: 48.62,
    r: 41.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.39,84.78C19.02,84.78,0,65.76,0,42.39S19.02,0,42.39,0s42.39,19.02,42.39,42.39-19.02,42.39-42.39,42.39ZM42.39.8C19.46.8.8,19.46.8,42.39s18.65,41.58,41.58,41.58,41.58-18.65,41.58-41.58S65.32.8,42.39.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.69,59.25c1.79-1.25,3.6-2.75,5.44-4.5,1.84-1.75,3.41-3.63,4.72-5.66,1.31-2.03,1.96-3.96,1.96-5.8,0-1.15-.32-2.05-.96-2.72-.64-.67-1.52-1-2.64-1-1.23,0-2.39.33-3.5.98-1.11.65-2.01,1.53-2.7,2.62l-3.08-3.2c.93-1.57,2.22-2.79,3.86-3.66,1.64-.87,3.46-1.3,5.46-1.3,2.91,0,5.19.71,6.86,2.14,1.67,1.43,2.5,3.41,2.5,5.94,0,2.35-.92,4.87-2.76,7.56-1.84,2.69-4.35,5.52-7.52,8.48h11.24v4.28h-18.88v-4.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuto2);
export default __webpack_public_path__ + "static/media/Tuto2.2ca9020b1cca10a6fac3c9b403c90947.svg";
export { ForwardRef as ReactComponent };